import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

const PickItemQuantityCounterContainer = ({ children }) => (
  <Box
    component={Paper}
    display="flex"
    mt="auto"
    justifyContent="space-between"
    alignItems="flex-end"
    position="sticky"
    bottom="3rem"
    square
    elevation={0}
    px={2}
    py={1}
  >
    {children}
  </Box>
);

PickItemQuantityCounterContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PickItemQuantityCounterContainer;
